import APP_CONST from '../../constants';

const reductions = {

    SET_LAYOUT : (state, action) => action.payload || APP_CONST.LAYOUT_FULL

};

const reducer = (state = null, action) => {
    if(action && action.type && reductions[action.type]) {
        return reductions[action.type](state, action)
    }
    return state;
};

export default reducer;